module.exports = {
  Accelerometer : {},
  Gyroscope : {},
}
